module.exports = __webpack_public_path__ + "../resources/img/ic_network_offline.fbd5876f.svg";